import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { TITLE_HOLDERS_ACTION_TYPE } from '../actions';

const initialState = {};

const titleHoldersReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case TITLE_HOLDERS_ACTION_TYPE.GET_TITLE_HOLDERS:
        return payload || initialState;

      case TITLE_HOLDERS_ACTION_TYPE.CREATE_TITLE_HOLDER:
      case TITLE_HOLDERS_ACTION_TYPE.EDIT_TITLE_HOLDER:
        draft[payload.titleHolderId] = payload;
        break;

      case TITLE_HOLDERS_ACTION_TYPE.DELETE_TITLE_HOLDER:
        delete draft[meta.titleHolderId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default titleHoldersReducer;
